module.exports = __webpack_public_path__ + "assets/img/icon_qrcode_big5.ed0407a4.png";